module.exports = __webpack_public_path__ + "static/img/image1.1637310493862.png";